// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file shared/pagination.proto (package gx.shared, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file shared/pagination.proto.
 */
export const file_shared_pagination = /*@__PURE__*/
  fileDesc("ChdzaGFyZWQvcGFnaW5hdGlvbi5wcm90bxIJZ3guc2hhcmVkIkIKEVBhZ2luYXRpb25SZXF1ZXN0Eg0KBXRvdGFsGAEgASgFEhMKBmN1cnNvchgCIAEoCUgAiAEBQgkKB19jdXJzb3IifwoSUGFnaW5hdGlvblJlc3BvbnNlEg0KBXRvdGFsGAEgASgFEhwKD3ByZXZpb3VzX2N1cnNvchgCIAEoCUgAiAEBEhgKC25leHRfY3Vyc29yGAMgASgJSAGIAQFCEgoQX3ByZXZpb3VzX2N1cnNvckIOCgxfbmV4dF9jdXJzb3JCmQEKDWNvbS5neC5zaGFyZWRCD1BhZ2luYXRpb25Qcm90b1ABWjJnaXRodWIuY29tL2dhbGF4eS1pby9neC9zaGFyZWQvZ28vY29udHJhY3RzL3NoYXJlZKICA0dTWKoCCUd4LlNoYXJlZMoCCUd4XFNoYXJlZOICFUd4XFNoYXJlZFxHUEJNZXRhZGF0YeoCCkd4OjpTaGFyZWRiBnByb3RvMw");

/**
 * Describes the message gx.shared.PaginationRequest.
 * Use `create(PaginationRequestSchema)` to create a new message.
 */
export const PaginationRequestSchema = /*@__PURE__*/
  messageDesc(file_shared_pagination, 0);

/**
 * Describes the message gx.shared.PaginationResponse.
 * Use `create(PaginationResponseSchema)` to create a new message.
 */
export const PaginationResponseSchema = /*@__PURE__*/
  messageDesc(file_shared_pagination, 1);

